module.exports = __webpack_public_path__ + "static/media/preto.f919d9ea.png";